import { render, staticRenderFns } from "./MisProgramasPostgradoPage.vue?vue&type=template&id=298afbbd&scoped=true&"
import script from "./MisProgramasPostgradoPage.js?vue&type=script&lang=js&"
export * from "./MisProgramasPostgradoPage.js?vue&type=script&lang=js&"
import style0 from "./MisProgramasPostgradoPage.vue?vue&type=style&index=0&id=298afbbd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "298afbbd",
  null
  
)

export default component.exports